// "Why this match" panel disabled — imports below are only used by the
// commented-out implementation inside the component (uncomment to restore).
// import { useState } from 'react';
// import { AnimatePresence, motion } from 'framer-motion';
// import { Sparkles } from 'lucide-react';
// import { warmEase } from '@/shared/motion/motionPresets';

type NavigatorReasonCalloutProps = {
  reason: string;
  /** Micro-label above the rationale (from navigatorResultsCopy). */
  label?: string;
};

/** Reasons short enough to always fit ~3 lines skip the toggle. */
// const READ_MORE_THRESHOLD = 220;

// ponytail: 3 lines of text-sm (14px) x leading-relaxed (1.625) ≈ 69px. The
// fixed collapse height couples to those two classes on the paragraph below;
// upgrade path is measuring the rendered line height with a ref if the
// typography ever changes.
// const COLLAPSED_HEIGHT = 69;

/**
 * AI match rationale ("why this match") — the featured card's highlighted
 * summary. Tinted like the advisor's voice so it reads distinct from the
 * plain provider bio below it. Expand/collapse animates height with a soft
 * bottom fade while collapsed (feature 080 visual hierarchy).
 *
 * Render disabled: this panel is hidden from the UI (see return null below).
 */
export const NavigatorReasonCallout = (
  _props: NavigatorReasonCalloutProps,
) => {
  return null;

  /* Original implementation (uncomment to restore the "why this match" panel):
  const { reason, label = 'Why this match' } = _props;
  const [expanded, setExpanded] = useState(false);
  // Empty copy hides the whole panel — label, icon and all.
  const text = reason.trim();
  if (!text) return null;

  const showToggle = text.length > READ_MORE_THRESHOLD;
  const collapsed = showToggle && !expanded;

  return (
    <div className="mt-3 rounded-xl border border-sage/20 bg-sage-bg px-4 py-3">
      <p className="mb-1.5 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-sage">
        <Sparkles className="h-3 w-3" aria-hidden />
        {label}
      </p>
      <motion.div
        initial={false}
        animate={{ height: collapsed ? COLLAPSED_HEIGHT : 'auto' }}
        transition={{ duration: 0.3, ease: warmEase }}
        className="relative overflow-hidden"
      >
        <p className="text-sm leading-relaxed text-text-primary">{text}</p>
        <AnimatePresence initial={false}>
          {collapsed && (
            // Soft fade instead of a hard clip — signals there is more to read.
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2, ease: warmEase }}
              className="pointer-events-none absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-sage-bg to-transparent"
              aria-hidden
            />
          )}
        </AnimatePresence>
      </motion.div>
      {showToggle && (
        <button
          type="button"
          onClick={() => setExpanded((current) => !current)}
          aria-expanded={expanded}
          className="mt-1 text-xs font-medium text-sage transition-colors duration-150 ease-out hover:text-[hsl(169_95%_18%)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-emphasis"
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  );
  */
};
